import { render, staticRenderFns } from "./wodejiande.vue?vue&type=template&id=0923a943&scoped=true&"
import script from "./wodejiande.vue?vue&type=script&lang=js&"
export * from "./wodejiande.vue?vue&type=script&lang=js&"
import style0 from "./wodejiande.vue?vue&type=style&index=0&id=0923a943&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0923a943",
  null
  
)

export default component.exports